import { ApplicationSettingEnum } from '../enums';

export class GetApplicationSettingsInput {
    public keys: Array<ApplicationSettingEnum> = [];
}
